
/**
 * return the first available input uuid or null
 * @param {Object} library the library object
 * @returns {string | null} returns a uuid string or null
 */
export function getFirstAvailableInputUuid(library) {
  return library.getConfigManager().listInputs()[0]?.getUUID() || null;
}